export default "__VITE_ASSET__CHUTkPFw__"